export default "__VITE_ASSET__ChGsCyo0__"